export const DEFAULT_OPENAI_MODEL = 'gpt-6.1-sol'
export const DEFAULT_ANTHROPIC_MODEL = 'claude-sonnet-5-5'
export const DEFAULT_GEMINI_MODEL = 'gemini-3-flash-preview'
